const heading3 = [
  "M2.76 12.02V8.64h3.66v3.38h1.55V3.84H6.42V7.2H2.76V3.84H1.2v8.18zm9.18.14a3.01 3.01 0 0 0 1.98-.75 2.92 2.92 0 0 0 .87-1.97 2.76 2.76 0 0 0-.45-1.6 2.6 2.6 0 0 0-1.36-.95l1.66-1.6V3.84H9.53v1.45h3.29l-2.2 1.83.68 1.22c.2-.12.41-.18.64-.18a1.24 1.24 0 0 1 1.28 1.28 1.29 1.29 0 0 1-2.2.9 1.24 1.24 0 0 1-.3-.57l-1.51.4a2.8 2.8 0 0 0 2.73 2z"
];
export {
  heading3
};
//# sourceMappingURL=heading3.js.map
